// Status (SUBSCRIBED / UNSUBSCRIBED) is on the API now. UI column + Excel: see EMAIL-FOLLOWUP.md.
import React, { useEffect, useState } from "react";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import Sidebar from "../../directives/sidebar";
import DataTable, { createTheme } from "react-data-table-component";
import { getAllEmailInsights } from "../../Action/action";
import customStyles from "../CustomStyles";
import moment from "moment";
import { IoCopyOutline } from "react-icons/io5";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast, { Toaster } from "react-hot-toast";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Download } from "lucide-react";
createTheme(
  "darkTheme",
  {
    text: {
      primary: "#FFFFFF",
      secondary: "#9CA3AF",
    },
    background: {
      default: "#0d1635",
    },
    context: {
      background: "#151c33",
      text: "#FFFFFF",
    },
    divider: {
      default: "transparent",
    },
    action: {
      button: "rgba(255,255,255,.7)",
      hover: "rgba(79, 70, 229, 0.2)", // hover color
      disabled: "rgba(255,255,255,.3)",
    },
  },
  "dark",
);

const EmailInsights = () => {
  const [searchText, setSearchText] = useState("");
  const [insights, setInsights] = useState([]);

  const [loader, setLoader] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");



  const closeModal = () => {
    setModalOpen(false);
    setModalTitle("");
    setModalText("");
  };

  useEffect(() => {
    getAllEmailInsight();
  }, []);
  const getAllEmailInsight = async () => {
    setLoader(true);
    try {
      const res = await getAllEmailInsights();
      setInsights(res.data);
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setLoader(false);
    }
  };

  const copieBtn = async () => {
    toast.success(`Copied!`);
  };
  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
    },

    {
      name: "Email",
      selector: (row) => row.email,
      exportValue: (row) => row.email, // 👈 add this
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>{row?.email}</span>
          <CopyToClipboard text={row?.email}>
            <span
              title="Click to Copy"
              className="mr-copylink"
              id="token-buy-button"
              onClick={copieBtn}
              style={{ cursor: "pointer", color: "#ea5536", marginLeft: 8 }}
            >
              <IoCopyOutline />
            </span>
          </CopyToClipboard>
        </div>
      ),
    },

    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD/MM/YY"),
      center: true,
    },
  ];

  const filteredData = insights?.filter((item) =>
    ["email"].some((key) =>
      item[key]?.toLowerCase().includes(searchText.toLowerCase()),
    ),
  );
  const handleDownload = async () => {
    try {
      if (!filteredData || filteredData.length === 0) {
        toast.error("No data to export");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Email Insights");

      worksheet.columns = [
        { header: "S.No", key: "sno", width: 10 },
        { header: "Email", key: "email", width: 35 },
        { header: "Date", key: "date", width: 20 },
      ];

      filteredData.forEach((item, index) => {
        worksheet.addRow({
          sno: index + 1, // 👈 serial number
          email: item.email || "",
          date: item.createdAt ? moment(item.createdAt).format("DD/MM/YY") : "",
        });
      });

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };

      worksheet.getColumn("sno").alignment = { horizontal: "center" };
      worksheet.autoFilter = {
        from: "A1",
        to: "F1",
      };
      // ✅ Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        "Email_Insights_Requests.xlsx",
      );
    } catch (error) {
      console.error("Excel download error:", error);
      toast.error("Failed to download Excel");
    }
  };
  return (
    <>
      <div className="wrapper h-auto" style={{ height: "100vh" }}>
        <Header />
        <Sidebar />
        <Toaster />

        <div
          className="content-wrapper"
          style={{ height: "100vh", overflowY: "scroll" }}
        >
          <div className="container-full">
            <section className="content">
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="box">
                    <div className="box-header with-border d-flex justify-content-between align-items-center">
                      <h3 className="box-title" style={{ fontWeight: 600 }}>
                        Email Insights
                      </h3>
                  <div className="d-flex gap-3 justify-content-end">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          style={{ width: "250px" }}
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button
                          onClick={handleDownload}
                          className="btn btn-primary "
                        >
                          <Download />
                        </button>
                      </div>
                    </div>
                    <div className="box-body">
                      {!loader ? (
                        <div className="table-responsive">
                          <DataTable
                            columns={columns}
                            data={filteredData}
                            pagination
                            striped
                            highlightOnHover
                            theme="darkTheme"
                            customStyles={customStyles}
                          />
                        </div>
                      ) : (
                        <>
                          <br />
                          <br />
                          <center>
                            <h4>
                              <i className="fa fa-spinner fa-spin"></i> &nbsp;
                              Please wait
                            </h4>
                          </center>
                          <br />
                          <br />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        {/* Modal popup for full Subject/Message */}
        {modalOpen && (
          <div
            onClick={closeModal}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "#fff",
                padding: 20,
                borderRadius: 8,
                maxWidth: 800,
                width: "30%",
                boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <h4 style={{ margin: 0 }}>{modalTitle}</h4>
                <button
                  onClick={closeModal}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: 20,
                    cursor: "pointer",
                  }}
                  aria-label="Close"
                >
                  ×
                </button>
              </div>
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {modalText}
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </>
  );
};

export default EmailInsights;
